import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BankDto } from '@cradua/data';
import Swal from 'sweetalert2';


@Component({
  selector: 'cradua-bank',
  templateUrl: './bank.component.html',
  styleUrls: ['./bank.component.scss']
})
export class BankComponent implements OnChanges {

  bankForm: FormGroup;
  bankFormArray: FormGroup;
  control = new FormControl();
  @Input() banks: BankDto[];
  @Input() routeAnimationsElements: any;
  @Output() bank = new EventEmitter<BankDto[]>()
  @Output() deleteBankEvent = new EventEmitter<any>()

    selectedBank: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createBankForm();
    }

    createBankForm() {
      this.bankForm = this.fb.group({
        BankName: ['', Validators.required],
        id: null
        });
        this.bankFormArray = this.fb.group({ Banks: this.fb.array([])
          });
        this.setBank();
    }

  // method to display banks
  setBank() {
    const control  = this.bankFormArray.controls.Banks as FormArray;
    this.banks.forEach( e => {
      control.push(
        this.fb.group({
          BankName: e.BankName,
          id: e.id
        })
      );
    });
  }


  // method to add Bank
  addBank(value: BankDto) {
    const control  = this.bankFormArray.controls.Banks as FormArray;
    control.insert(0,
          this.fb.group({
            BankName: value.BankName,
            id: null
          })
       );
  }

  selectBank(value) {}

  // method to delete bank from arrary list
  deleteBank(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.bankFormArray.controls.Banks as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.banks.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.banks[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: BankDto) {
    if(this.bankForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.bankFormArray.get('Banks')['controls'][this.selectedIndex].patchValue({BankName: formValue.BankName});
    } else {
      this.addBank(formValue);
    }
    this.selectedIndex = null;
    this.bankForm.reset()
  }

  onEdit(index, value: BankDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.bankForm.patchValue({BankName: value.BankName});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.bankForm.reset();
  }

  onSubmit(formValue: BankDto[]) {
  this.bank.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteBankEvent.emit(this.filteredDelete);
  }
  }

}
